<template>
  <nav class="menu">
    <router-link
      v-for="(nav, index) in navigations"
      :key="index"
      :to="getPath(nav)"
      tag="div"
      class="menu__item"
      :class="{ menu__item_selected: selectedMenuElement(nav.path) }"
    >
      {{ nav.name }}
    </router-link>
  </nav>
</template>

<script>
export default {
  name: "AppMenu",
  props: {
    navigations: Array
  },
  computed: {},
  methods: {
    selectedMenuElement(path) {
      return this.$route.path == path;
    },
    getPath(nav) {
      let result = nav.path;
      if (nav?.params?.length > 0) {
        let prm = "";
        nav.params.forEach(p => {
          for (let key in p) {
            prm += `${key}=${p[key]}`;
          }
        });
        result = `${result}?${prm}`;
      }
      return result;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/css/variables.scss";

.menu {
  display: flex;

  .menu__item {
    display: flex;
    align-items: center;
    color: $header_text_color;
    padding: 0 15px;
    height: 100%;
    font-weight: 600;
  }

  .menu__item:hover {
    cursor: pointer;
    color: $primary_color;
  }

  .menu__item_selected {
    color: $company_color;
    background-color: $header_text_color;
  }
}
</style>
